export const API_ORIGIN = process.env.REACT_APP_API_URL.replace(/\/$/, '');
export const API_BASE = `${API_ORIGIN}/api`;